/**
 * Contact information for DIETRONIK Service
 * Centralized data to ensure consistency across the website
 */
export const contactInfo = {
  phone: {
    primary: "+49 7426 9649354",
    mobile: "+49 1590 1293720",
    display: "+49 7426 9649354 | +49 1590 1293720"
  },
  email: "info@dietronik-service.de",
  address: {
    street: "Hebelstraße 2",
    city: "Wehingen",
    postalCode: "78564",
    country: "Deutschland",
    full: "Hebelstraße 2, 78564 Wehingen",
    coordinates: {
      lat: 48.13074,  // Approximate coordinates for Wehingen
      lng: 8.79649
    }
  },
  hours: {
    weekdays: "8:00 - 17:00",
    saturday: "geschlossen",
    sunday: "geschlossen"
  }
};
